export default function featuredCarouselScript() {
  (function () {
    const intervalTimer = 5000;
    const slides = document.querySelectorAll('.featured-carousel__wrapper');
    let currentIndex = 0;
    let previousSlide = null;
    let currentSlide = document.querySelector(`.slide-${currentIndex + 1}`);
    if (currentSlide) {
      currentSlide.classList.add('--in-view');
      currentIndex++;
    }

    const carouselInterval = setInterval(() => {
      if (currentIndex === slides.length) {
        currentIndex = 0;
      }
      currentSlide = document.querySelector(`.slide-${currentIndex + 1}`);
      if (currentSlide) {
        currentSlide.classList.add('--in-view');
      }
      if (currentIndex === 0) {
        previousSlide = document.querySelector(`.slide-${slides.length}`);
      } else {
        previousSlide = document.querySelector(`.slide-${currentIndex}`);
      }
      if (previousSlide) {
        previousSlide.classList.remove('--in-view');
      }
      currentIndex++;
    }, intervalTimer);

    // Listen for block selection in editor.
    // This will update the selected block in the slider with --in-view class so it can be styled in the editor
    if (Shopify.designMode) {
      document.addEventListener('shopify:block:select', function shopifyEvent(event) {
        clearInterval(carouselInterval);
        const selectedBlock = event.detail.blockId;
        const selectedSlide = document.querySelector(`.featured-carousel__wrapper.--${selectedBlock}`);
        if (selectedSlide) {
          slides.forEach((slide) => slide.classList.remove('--in-view'));
          const selectedIndex = selectedSlide.getAttribute('data-index');
          currentIndex = selectedIndex - 1;
          selectedSlide.classList.add('--in-view');
        }
      });
    }
  })();
}
